import { render } from "./attendance-admin-modal.vue?vue&type=template&id=1c224a5e"
import script from "./attendance-admin-modal.vue?vue&type=script&lang=js"
export * from "./attendance-admin-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__